import dayjs from "dayjs";

export function shouldSendWsMessage(flag) {
  // const day = dayjs().day(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  const day = dayjs().utcOffset(330).day(); // fixed to IST
  const isWeekend = day === 0 || day === 6;

  if (!isWeekend) {
    // Monday to Friday
    console.log("Weekday OK to send");
    return true;
  } else {
    // Saturday or Sunday
    if (flag === 1) {
      console.log("Weekend but flag=1 OK to send");
      return true;
    } else {
      console.log("Weekend and flag=0 Not sending");
      return false;
    }
  }
}
